import * as _ from "lodash"

import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";

interface ISearchOptions {
  WB_ENTITY_ID_CUSTOMER?: number,
  WB_ENTITY_ID_PRODUCT?: number,
  WB_ENTITY_ID_PERIOD?: number
}


const vWB_Model_Compare_Modeling_Session_Fields: {[id:string]: ISearchProviderField } = {
  WB_MODELING_SESSION_ID:       {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Modeling Session WB Id',    columnResourceName: 'colModelingSessionWBId',   alignment: HorizAlignment.Center},  domainOptions: { }},
  MODELING_SESSION_ID:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Modeling Session Id',       columnResourceName: 'colId',                    alignment: HorizAlignment.Left},    domainOptions: {}},
  MODELING_SESSION_NAME:        {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Modeling Session Name',     columnResourceName: 'colModelName',             alignment: HorizAlignment.Left},    domainOptions: {}},
  WB_MODEL_ID:                  {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Model WB ID',               columnResourceName: 'colModel',                 alignment: HorizAlignment.Left},    domainOptions: {}},
  MODEL_ID:                     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model ID',                  columnResourceName: 'colModelId',               alignment: HorizAlignment.Left},    domainOptions: {}},
  MODEL_NAME:                   {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model',                     columnResourceName: 'colModelName',             alignment: HorizAlignment.Left},    domainOptions: {}},
  WB_ENTITY_ID_CUSTOMER:        {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Customer Entity WB ID',     columnResourceName: 'colCustEntityId',          alignment: HorizAlignment.Left},    domainOptions: {}},
  WB_ENTITY_ID_PRODUCT:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Product Entity WB ID',      columnResourceName: 'colCustEntityId',          alignment: HorizAlignment.Left},    domainOptions: {}},
  WB_ENTITY_ID_PERIOD:          {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Period Entity WB ID',       columnResourceName: 'colCustEntityId',          alignment: HorizAlignment.Left},    domainOptions: {}},
  CUSTOMER_LEVEL:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer Level',            columnResourceName: 'colCustLevel',             alignment: HorizAlignment.Left},    domainOptions: { profileId: "ModelingSessionRefValuesByListSearchProfile", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  PRODUCT_LEVEL:                {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Level',             columnResourceName: 'colPrdLevel',              alignment: HorizAlignment.Left},    domainOptions: { profileId: "ModelingSessionRefValuesByListSearchProfile", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  PRODUCT_TYPE:                 {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Type',              columnResourceName: 'colPrdType',               alignment: HorizAlignment.Left},    domainOptions: { profileId: "ModelingSessionRefValuesByListSearchProfile", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  PERIOD_LEVEL:                 {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Period Level',              columnResourceName: 'colPeriodLevel',           alignment: HorizAlignment.Left},    domainOptions: { profileId: "ModelingSessionRefValuesByListSearchProfile", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  WB_PERIODH_ID:                {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Period Hierarchy WB Id',    columnResourceName: 'colPrdHWBId',              alignment: HorizAlignment.Center},  domainOptions: { maxLength: 5}},
  WB_SALESORG_ID: {
    type: SearchProviderFieldType.number,
    renderOptions: {
      columnName: 'wb Sales Org',
      columnResourceName: 'colSalesOrgId',
      alignment: HorizAlignment.Left
    },
    domainOptions: {}
  },
  SALESORG_ID: {
    type: SearchProviderFieldType.string,
    renderOptions: {columnName: 'SalesOrg Id', columnResourceName: 'colSalesOrgId', alignment: HorizAlignment.Left},
    domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
  },
  SALESORG_NAME: {
    type: SearchProviderFieldType.string,
    renderOptions: {columnName: 'Sales Org', columnResourceName: 'colSalesOrgName', alignment: HorizAlignment.Left},
    domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
  }
}

const vWB_Model_Compare_Modeling_Session_KeyFields =
  {id:    'WB_MODELING_SESSION_ID',
   id_ui: '',
   name:  ''}


class ModelCompareModelingSessionByListSearchProvider
  implements  ISearchProvider {

  arrWB_Modeling_Session_Ids: number[] = []
  options: ISearchOptions = {}
  _searchProviderFields: {[id:string]: ISearchProviderField } = {}

  constructor(WB_ModelingSession_Ids: number[], options: ISearchOptions,  aSearch: ISearch){
    this.arrWB_Modeling_Session_Ids = WB_ModelingSession_Ids
    this.options = options
    this._searchProviderFields = _.cloneDeep(vWB_Model_Compare_Modeling_Session_Fields)
  }

  get keyFields() { return vWB_Model_Compare_Modeling_Session_KeyFields }

  get searchProviderFields(){
    return this._searchProviderFields
  }

  search(requestSpec: ISearchRequestSubset): Promise<any[]> {
    const self = this
    return new Promise<any[]>((resolve, error) => {

      if(!_.isEmpty(this.options)) {
        requestSpec.where.WB_ENTITY_ID_CUSTOMER = this.options.WB_ENTITY_ID_CUSTOMER
        requestSpec.where.WB_ENTITY_ID_PRODUCT = this.options.WB_ENTITY_ID_PRODUCT
        requestSpec.where.WB_ENTITY_ID_PERIOD = this.options.WB_ENTITY_ID_PERIOD
      }

      let findRequest = SearchUtils.makeSearchRequest(requestSpec,
          'vUI_Model_Compare_Modeling_Sessions' , //
          self.searchProviderFields,
          [])

      PASearch.findByRequest(findRequest)
          .then((res: any[]) => {
            if(!_.isEmpty(this.arrWB_Modeling_Session_Ids)) {
              let keyIds = _.keyBy(this.arrWB_Modeling_Session_Ids, anId => anId)
              res = _.filter(res, (aRes: any) => !(aRes.WB_MODELING_SESSION_ID in keyIds))
            }
            resolve(res)
          })
          .catch((err)=> {
            error(err)
          })
    })
  }

  distinctValues(fieldName: string): Promise<string[] | number[]> {
    const self = this
    return new Promise<string[] | number[]>((resolve, error) => {
      let findRequest = SearchUtils.makeSearchRequest({
            },
          'vUI_Model_Compare_Modeling_Sessions',
          self.searchProviderFields,
          [fieldName])

      PASearch.findByRequest(findRequest)
          .then((res: any[]) => {

            resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
          })
          .catch((err)=> {
            error(err)
          })
    })
  }

}


class ModelCompareModelingSessionByListSearchProfile
  implements  ISearchProfile {

  aSearchProvider: ISearchProvider = undefined

  profileId = "default"
  profileName = "AutoSearch Only"
  renderOptions = { ui5ResourceId: "ModelCompareModelingSessionByListProfile" }

  profileFilter: IProfileFilter[] = [
      {profileFilterName: 'Id', searchProviderFieldId: 'MODELING_SESSION_ID', renderOptions: { }},
      {profileFilterName: 'Name', searchProviderFieldId: 'MODELING_SESSION_NAME', renderOptions: { }}
  ]

  profileDisplayFields = [
    'MODELING_SESSION_ID', 'MODELING_SESSION_NAME', 'MODEL_ID', 'MODEL_NAME', 'CUSTOMER_LEVEL', 'PRODUCT_LEVEL', 'PERIOD_LEVEL', 'SALESORG_NAME'
  ]

  profileTreeIdDefault = "default"
  profileTrees: ITree[] = [
    {treeId: "default",
      treeName: "By Hierarchy",
      nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "No Customer Tree Path Set", levelDelimiter: "\\", ruggedTree: true})],
      renderOptions: {}}
  ]

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault = ""    //string;
  profileSorts: ISearchSort[] = [] //ISearchSort[];


  constructor(WB_ModelingSession_Ids: number[], options:ISearchOptions, aSearch: ISearch){
    this.aSearchProvider = new ModelCompareModelingSessionByListSearchProvider(WB_ModelingSession_Ids, options, aSearch)
  }

  get profileSearchProvider(){ return this.aSearchProvider }

}


export class ModelCompareModelingSessionByList
  implements  ISearch {

  constructor(WB_ModelingSession_Ids: number[], options?: ISearchOptions){
    this.searchProfiles = [ new ModelCompareModelingSessionByListSearchProfile(WB_ModelingSession_Ids, options, this) ]
  }

  searchName = "Select ModelCompareModelingSession(s)"
  renderOptions = { ui5ResourceId: "ModelCompareModelingSessionByList"}
  searchProfileIdDefault = "default"
  searchProfiles: ISearchProfile[] = []
  autoSearch = true

}
